import { render, staticRenderFns } from "./NavigationMobileItemSubmenu.vue?vue&type=template&id=f8158b3a&"
import script from "./NavigationMobileItemSubmenu.vue?vue&type=script&lang=js&"
export * from "./NavigationMobileItemSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports